import React from "react";
import styled from "styled-components";
import { LIVE_CHANNEL_TOGGLE_TOKENS } from "./liveChannelTokens";

const ToggleLabel = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 18px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
`;

const ToggleInput = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const ToggleTrack = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 34px;
  height: 18px;
  padding: 2px;
  border-radius: 999px;
  background: ${({ $checked, $disabled }) => {
    if ($disabled) {
      return $checked ? LIVE_CHANNEL_TOGGLE_TOKENS.trackOn : LIVE_CHANNEL_TOGGLE_TOKENS.trackDisabled;
    }

    return $checked ? LIVE_CHANNEL_TOGGLE_TOKENS.trackOn : LIVE_CHANNEL_TOGGLE_TOKENS.trackOff;
  }};
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  ${ToggleInput}:focus-visible + & {
    box-shadow: ${LIVE_CHANNEL_TOGGLE_TOKENS.focus};
  }
`;

const ToggleThumb = styled.span`
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${LIVE_CHANNEL_TOGGLE_TOKENS.thumb};
  box-shadow: ${LIVE_CHANNEL_TOGGLE_TOKENS.thumbShadow};
  transform: translateX(${({ $checked }) => ($checked ? "18px" : "0")});
  transition: transform 0.2s ease;
`;

export default function ChannelToggle({
  checked,
  disabled,
  onChange,
  name,
  ariaLabel,
}) {
  return (
    <ToggleLabel $disabled={disabled}>
      <ToggleInput
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        aria-label={ariaLabel}
      />
      <ToggleTrack $checked={checked} $disabled={disabled}>
        <ToggleThumb $checked={checked} />
      </ToggleTrack>
    </ToggleLabel>
  );
}
